
export enum BvAPeriodSelection
{
  CurrentYear = 'Current Year',
  CurrentPeriod = 'Current Period',
  CurrentYearAllPeriods = 'Current Year - All Periods',
}

export enum BvAViewSelection
{
  TableView = 'Table View',
  ChartView = 'Chart View'
}
